/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * agora/v1/support.proto
 * OpenAPI spec version: version not set
 */

/**
 * The permission level for support access.

 - SUPPORT_PERMISSION_LEVEL_UNSPECIFIED: Unspecified permission level.
 - SUPPORT_PERMISSION_LEVEL_VIEW_ONLY: View-only access.
Support can view configuration, logs, and execution details but cannot make changes.
 - SUPPORT_PERMISSION_LEVEL_VIEW_AND_EDIT: View and edit access.
Support can view and modify configuration, apply changes, and trigger actions.
 */
export type V1SupportPermissionLevel =
  (typeof V1SupportPermissionLevel)[keyof typeof V1SupportPermissionLevel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1SupportPermissionLevel = {
  SUPPORT_PERMISSION_LEVEL_UNSPECIFIED: 'SUPPORT_PERMISSION_LEVEL_UNSPECIFIED',
  SUPPORT_PERMISSION_LEVEL_VIEW_ONLY: 'SUPPORT_PERMISSION_LEVEL_VIEW_ONLY',
  SUPPORT_PERMISSION_LEVEL_VIEW_AND_EDIT:
    'SUPPORT_PERMISSION_LEVEL_VIEW_AND_EDIT',
} as const;
